export default "__VITE_ASSET__6f9e41f0__"